<div class="d-flex flex-column justify-content-center align-items-center h-100">
    <app-icon class="upload" src="upload"></app-icon>
    <div class="text">
        <p>Drag & Drop a file to upload</p>
        <p>JPG, GIF or PNG files</p>
    </div>
</div>
